{
  "name": "@stackwright-pro/launch-stackwright-pro",
  "version": "0.4.0-alpha.146",
  "description": "Launch a new Stackwright Pro project with OpenAPI integration, auth, and the otter raft",
  "license": "SEE LICENSE IN LICENSE",
  "publishConfig": {
    "access": "public"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/Per-Aspera-LLC/stackwright-pro"
  },
  "keywords": [
    "stackwright",
    "stackwright-pro",
    "scaffolding",
    "openapi",
    "government",
    "hackathon"
  ],
  "files": [
    "dist",
    "templates"
  ],
  "bin": {
    "launch-stackwright-pro": "dist/index.js"
  },
  "scripts": {
    "build": "node ../../scripts/sync-versions.mjs && tsup",
    "sync-versions": "node ../../scripts/sync-versions.mjs",
    "dev": "tsup --watch",
    "test": "vitest run",
    "test:coverage": "vitest run --coverage"
  },
  "dependencies": {
    "@stackwright-pro/auth": "workspace:*",
    "@stackwright-pro/auth-nextjs": "workspace:*",
    "@stackwright-pro/mcp": "workspace:*",
    "@stackwright-pro/openapi": "workspace:*",
    "@stackwright-pro/otters": "workspace:*",
    "@stackwright-pro/scaffold-hooks": "workspace:*",
    "@stackwright/cli": "^0.9.0",
    "@stackwright/scaffold-core": "^0.3.3",
    "chalk": "^5.6.2",
    "commander": "^15.0.0",
    "fs-extra": "^11.3.5",
    "js-yaml": "^4.2.0"
  },
  "devDependencies": {
    "@types/fs-extra": "^11.0",
    "@types/js-yaml": "^4.0.9",
    "@types/node": "catalog:",
    "tsup": "catalog:",
    "typescript": "catalog:",
    "vitest": "catalog:"
  }
}
